import React from "react";
import Alert from "./Alert";

export default ({ children, position = "fixed" }) => (
  <Alert appearance="error" position={position}>
    {children}
  </Alert>
);
